import { atom, useAtom } from "jotai";
import dataService from "../../helpers/dataService";

const legalFormsAtom = atom([]);

const useLegalForms = () => {
  const [legalForms, setLegalForms] = useAtom(legalFormsAtom);

  const getLegalForms = () => {
    dataService.get(`constants/formes-juridiques`, (data) =>
      setLegalForms(
        (data || []).map((item) => ({
          id: item.id,
          name: item.libelle,
          modulrId: item.code,
        }))
      )
    );
  };

  return {
    legalForms,
    legalFormsActions: {
      getLegalForms,
    },
  };
};

export default useLegalForms;
